import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import { isEmpty, any, uniq } from 'underscore';
import { HotspotPanel } from '@bingads-webui-campaign-react/responsive-ad-editor-components';
import { I18nContext } from '@bingads-webui-react/i18n-context';
import { withCustomValidation, withError } from '@bingads-webui-react/validation';
import { withUnvalidatedControlErrors, withControlErrorHandling } from '@bingads-webui-campaign-react/error-handling';
import { entityIs, andComp, propertyIs } from '@bingads-webui-campaign-react/form-error';
import { ERROR_ENTITY } from '../constants';

const nativeAdHotspotsProp = andComp(entityIs(ERROR_ENTITY.Ad), propertyIs('Uri'));

const ValidatedHotspotInternal = ({
  updateValidation,
  validationProps,
}) => {
  const i18n = useContext(I18nContext);

  const { data = {} } = validationProps;

  const { hotspots } = data;

  const validateHotSpot = (newHostpots) => {
    const missField = newHostpots.map(i =>
      isEmpty(i.glyph) || isEmpty(i.title) || isEmpty(i.actionText) || isEmpty(i.uri) ||
      (isEmpty(i.placement)));

    if (any(missField)) {
      return [i18n.getString(_TL_('HotSpot missing required field'))];
    }

    // check if any duplicate hotspot
    const hotspotStrings = newHostpots.map(hotspot => hotspot.title + hotspot.actionText + hotspot.desc + hotspot.uri + hotspot.glyph);

    if (newHostpots.length !== uniq(hotspotStrings).length) {
      return [i18n.getString(_TL_('HotSpots duplication'))];
    }

    return [];
  };

  const onUpdateHotspots = (newHostpots) => {
    updateValidation(validateHotSpot(newHostpots), { hotspots: [...newHostpots] });
  };

  return (
    <HotspotPanel
      onUpdateHotspots={onUpdateHotspots}
      enableHotSpotPlacement
      i18n={i18n}
      hideTitle
      showHotspotCount
      hotspots={hotspots || []}
    />
  );
};

ValidatedHotspotInternal.propTypes = {
  updateValidation: PropTypes.func.isRequired,
  validationProps: PropTypes.shape({
    data: PropTypes.shape({
      hotspots: PropTypes.shape({}),
    }),
  }).isRequired,
};

export const ValidatedHotspot = withControlErrorHandling(withUnvalidatedControlErrors(
  withError(withCustomValidation(ValidatedHotspotInternal)),
  { filter: nativeAdHotspotsProp }
));
